export default __webpack_public_path__ + "static/media/success-payment.72e2c5a5.png";